import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Lock } from 'lucide-react';
interface CheckoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CheckoutModal({
  isOpen,
  onClose
}: CheckoutModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-58">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center" data-id="element-59">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-60" />

          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-4xl h-[90vh] md:h-[85vh] bg-white md:rounded-xl shadow-2xl overflow-hidden flex flex-col" data-id="element-61">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-100" data-id="element-62">
              <div className="flex items-center gap-2 text-gray-600 text-sm font-medium" data-id="element-63">
                <Lock className="w-4 h-4 text-green-600" data-id="element-64" />
                <span data-id="element-65">Pago Seguro y Encriptado</span>
              </div>
              <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-66">
                <X className="w-5 h-5" data-id="element-67" />
              </button>
            </div>

            {/* Iframe Container */}
            <div className="flex-1 w-full relative bg-white" data-id="element-68">
              {/* Loading State */}
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-white z-0" data-id="element-69">
                <div className="w-8 h-8 border-4 border-terracotta/20 border-t-terracotta rounded-full animate-spin mb-4" data-id="element-70" />
                <p className="text-gray-500 font-medium animate-pulse" data-id="element-71">
                  Cargando pago seguro...
                </p>
              </div>

              <iframe src="https://impulsodigital.vip/cart/44791114629206:1" className="absolute inset-0 w-full h-full border-none z-10 bg-white" title="Checkout Seguro" allow="payment" data-id="element-72" />
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}